"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateWorkflowTransitionPropertyWorkflowModeEnum = exports.GetWorkflowTransitionPropertiesWorkflowModeEnum = exports.DeleteWorkflowTransitionPropertyWorkflowModeEnum = exports.CreateWorkflowTransitionPropertyWorkflowModeEnum = exports.WorkflowTransitionPropertiesApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class WorkflowTransitionPropertiesApi extends runtime.BaseAPI {
    /**
     * Adds a property to a workflow transition. Transition properties are used to change the behavior of a transition. For more information, see [Transition properties](https://confluence.atlassian.com/x/zIhKLg#Advancedworkflowconfiguration-transitionproperties) and [Workflow properties](https://confluence.atlassian.com/x/JYlKLg).  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Create workflow transition property
     */
    createWorkflowTransitionPropertyRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['transitionId'] == null) {
                throw new runtime.RequiredError('transitionId', 'Required parameter "transitionId" was null or undefined when calling createWorkflowTransitionProperty().');
            }
            if (requestParameters['key'] == null) {
                throw new runtime.RequiredError('key', 'Required parameter "key" was null or undefined when calling createWorkflowTransitionProperty().');
            }
            if (requestParameters['workflowName'] == null) {
                throw new runtime.RequiredError('workflowName', 'Required parameter "workflowName" was null or undefined when calling createWorkflowTransitionProperty().');
            }
            if (requestParameters['workflowTransitionProperty'] == null) {
                throw new runtime.RequiredError('workflowTransitionProperty', 'Required parameter "workflowTransitionProperty" was null or undefined when calling createWorkflowTransitionProperty().');
            }
            const queryParameters = {};
            if (requestParameters['key'] != null) {
                queryParameters['key'] = requestParameters['key'];
            }
            if (requestParameters['workflowName'] != null) {
                queryParameters['workflowName'] = requestParameters['workflowName'];
            }
            if (requestParameters['workflowMode'] != null) {
                queryParameters['workflowMode'] = requestParameters['workflowMode'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/workflow/transitions/{transitionId}/properties`.replace(`{${"transitionId"}}`, encodeURIComponent(String(requestParameters['transitionId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.WorkflowTransitionPropertyToJSON)(requestParameters['workflowTransitionProperty']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.WorkflowTransitionPropertyFromJSON)(jsonValue));
        });
    }
    /**
     * Adds a property to a workflow transition. Transition properties are used to change the behavior of a transition. For more information, see [Transition properties](https://confluence.atlassian.com/x/zIhKLg#Advancedworkflowconfiguration-transitionproperties) and [Workflow properties](https://confluence.atlassian.com/x/JYlKLg).  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Create workflow transition property
     */
    createWorkflowTransitionProperty(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.createWorkflowTransitionPropertyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Deletes a property from a workflow transition. Transition properties are used to change the behavior of a transition. For more information, see [Transition properties](https://confluence.atlassian.com/x/zIhKLg#Advancedworkflowconfiguration-transitionproperties) and [Workflow properties](https://confluence.atlassian.com/x/JYlKLg).  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Delete workflow transition property
     */
    deleteWorkflowTransitionPropertyRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['transitionId'] == null) {
                throw new runtime.RequiredError('transitionId', 'Required parameter "transitionId" was null or undefined when calling deleteWorkflowTransitionProperty().');
            }
            if (requestParameters['key'] == null) {
                throw new runtime.RequiredError('key', 'Required parameter "key" was null or undefined when calling deleteWorkflowTransitionProperty().');
            }
            if (requestParameters['workflowName'] == null) {
                throw new runtime.RequiredError('workflowName', 'Required parameter "workflowName" was null or undefined when calling deleteWorkflowTransitionProperty().');
            }
            const queryParameters = {};
            if (requestParameters['key'] != null) {
                queryParameters['key'] = requestParameters['key'];
            }
            if (requestParameters['workflowName'] != null) {
                queryParameters['workflowName'] = requestParameters['workflowName'];
            }
            if (requestParameters['workflowMode'] != null) {
                queryParameters['workflowMode'] = requestParameters['workflowMode'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/workflow/transitions/{transitionId}/properties`.replace(`{${"transitionId"}}`, encodeURIComponent(String(requestParameters['transitionId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a property from a workflow transition. Transition properties are used to change the behavior of a transition. For more information, see [Transition properties](https://confluence.atlassian.com/x/zIhKLg#Advancedworkflowconfiguration-transitionproperties) and [Workflow properties](https://confluence.atlassian.com/x/JYlKLg).  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Delete workflow transition property
     */
    deleteWorkflowTransitionProperty(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.deleteWorkflowTransitionPropertyRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Returns the properties on a workflow transition. Transition properties are used to change the behavior of a transition. For more information, see [Transition properties](https://confluence.atlassian.com/x/zIhKLg#Advancedworkflowconfiguration-transitionproperties) and [Workflow properties](https://confluence.atlassian.com/x/JYlKLg).  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get workflow transition properties
     */
    getWorkflowTransitionPropertiesRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['transitionId'] == null) {
                throw new runtime.RequiredError('transitionId', 'Required parameter "transitionId" was null or undefined when calling getWorkflowTransitionProperties().');
            }
            if (requestParameters['workflowName'] == null) {
                throw new runtime.RequiredError('workflowName', 'Required parameter "workflowName" was null or undefined when calling getWorkflowTransitionProperties().');
            }
            const queryParameters = {};
            if (requestParameters['includeReservedKeys'] != null) {
                queryParameters['includeReservedKeys'] = requestParameters['includeReservedKeys'];
            }
            if (requestParameters['key'] != null) {
                queryParameters['key'] = requestParameters['key'];
            }
            if (requestParameters['workflowName'] != null) {
                queryParameters['workflowName'] = requestParameters['workflowName'];
            }
            if (requestParameters['workflowMode'] != null) {
                queryParameters['workflowMode'] = requestParameters['workflowMode'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/workflow/transitions/{transitionId}/properties`.replace(`{${"transitionId"}}`, encodeURIComponent(String(requestParameters['transitionId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.WorkflowTransitionPropertyFromJSON)(jsonValue));
        });
    }
    /**
     * Returns the properties on a workflow transition. Transition properties are used to change the behavior of a transition. For more information, see [Transition properties](https://confluence.atlassian.com/x/zIhKLg#Advancedworkflowconfiguration-transitionproperties) and [Workflow properties](https://confluence.atlassian.com/x/JYlKLg).  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get workflow transition properties
     */
    getWorkflowTransitionProperties(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getWorkflowTransitionPropertiesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates a workflow transition by changing the property value. Trying to update a property that does not exist results in a new property being added to the transition. Transition properties are used to change the behavior of a transition. For more information, see [Transition properties](https://confluence.atlassian.com/x/zIhKLg#Advancedworkflowconfiguration-transitionproperties) and [Workflow properties](https://confluence.atlassian.com/x/JYlKLg).  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Update workflow transition property
     */
    updateWorkflowTransitionPropertyRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['transitionId'] == null) {
                throw new runtime.RequiredError('transitionId', 'Required parameter "transitionId" was null or undefined when calling updateWorkflowTransitionProperty().');
            }
            if (requestParameters['key'] == null) {
                throw new runtime.RequiredError('key', 'Required parameter "key" was null or undefined when calling updateWorkflowTransitionProperty().');
            }
            if (requestParameters['workflowName'] == null) {
                throw new runtime.RequiredError('workflowName', 'Required parameter "workflowName" was null or undefined when calling updateWorkflowTransitionProperty().');
            }
            if (requestParameters['workflowTransitionProperty'] == null) {
                throw new runtime.RequiredError('workflowTransitionProperty', 'Required parameter "workflowTransitionProperty" was null or undefined when calling updateWorkflowTransitionProperty().');
            }
            const queryParameters = {};
            if (requestParameters['key'] != null) {
                queryParameters['key'] = requestParameters['key'];
            }
            if (requestParameters['workflowName'] != null) {
                queryParameters['workflowName'] = requestParameters['workflowName'];
            }
            if (requestParameters['workflowMode'] != null) {
                queryParameters['workflowMode'] = requestParameters['workflowMode'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/workflow/transitions/{transitionId}/properties`.replace(`{${"transitionId"}}`, encodeURIComponent(String(requestParameters['transitionId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.WorkflowTransitionPropertyToJSON)(requestParameters['workflowTransitionProperty']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.WorkflowTransitionPropertyFromJSON)(jsonValue));
        });
    }
    /**
     * Updates a workflow transition by changing the property value. Trying to update a property that does not exist results in a new property being added to the transition. Transition properties are used to change the behavior of a transition. For more information, see [Transition properties](https://confluence.atlassian.com/x/zIhKLg#Advancedworkflowconfiguration-transitionproperties) and [Workflow properties](https://confluence.atlassian.com/x/JYlKLg).  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Update workflow transition property
     */
    updateWorkflowTransitionProperty(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateWorkflowTransitionPropertyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.WorkflowTransitionPropertiesApi = WorkflowTransitionPropertiesApi;
/**
 * @export
 */
exports.CreateWorkflowTransitionPropertyWorkflowModeEnum = {
    Live: 'live',
    Draft: 'draft'
};
/**
 * @export
 */
exports.DeleteWorkflowTransitionPropertyWorkflowModeEnum = {
    Live: 'live',
    Draft: 'draft'
};
/**
 * @export
 */
exports.GetWorkflowTransitionPropertiesWorkflowModeEnum = {
    Live: 'live',
    Draft: 'draft'
};
/**
 * @export
 */
exports.UpdateWorkflowTransitionPropertyWorkflowModeEnum = {
    Live: 'live',
    Draft: 'draft'
};
//# sourceMappingURL=WorkflowTransitionPropertiesApi.js.map